export default __webpack_public_path__ + "static/media/default-blanquette.5c761ead.png";